/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_GroupType } from './models_GroupType';
export type groups_UpdateGroupRequest = {
    age_max?: number;
    age_min?: number;
    avatarUrl?: string;
    childcare_id?: string;
    color?: string;
    description?: string;
    icon?: string;
    /**
     * LeadEmployeeID is TRI-STATE (issue #1217): absent or null leaves the
     * value unchanged, "" clears it, a value sets it. This deliberately does
     * NOT copy the neighbouring childcare_id behaviour, where an absent field
     * means "clear" — that would silently wipe the lead on any partial update.
     * x-nullable is required: without it the generated OpenAPI/TypeScript
     * clients type the field as plain string and a strict client rejects the
     * valid null "unchanged" case.
     */
    lead_employee_id?: string | null;
    max_headcount?: number;
    max_weighted_headcount?: number;
    name?: string;
    sort_order?: number;
    status?: groups_UpdateGroupRequest.status;
    subsidy_type?: models_GroupType;
    type?: models_GroupType;
};
export namespace groups_UpdateGroupRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
}

